import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fdf7ff]">
        <div className="nb-card p-8 text-center" data-testid="auth-loading">
          <div className="animate-spin w-8 h-8 border-4 border-[#a21caf] border-t-transparent rounded-full mx-auto mb-4" />
          <p className="font-medium text-[#111]">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
}
